import type { NodeKind } from './types';

export type NodeCategory = 'dialog' | 'sensors' | 'action' | 'motion' | 'control' | 'utility' | 'flow';

type CategoryStyle = {
  label: { en: string; ja: string };
  palette: string;
  border: string;
  title: string;
  summary: string;
  miniMap: string;
};

export const NODE_CATEGORY_ORDER: NodeCategory[] = [
  'dialog',
  'sensors',
  'action',
  'motion',
  'control',
  'utility',
  'flow',
];

export const NODE_CATEGORY_STYLES: Record<NodeCategory, CategoryStyle> = {
  dialog: {
    label: { en: 'Dialog', ja: 'ダイアログ' },
    palette: 'bg-lime-50 border-lime-500 text-lime-800',
    border: 'border-lime-500',
    title: 'text-lime-800',
    summary: 'text-lime-700',
    miniMap: '#84cc16',
  },
  sensors: {
    label: { en: 'Sensors', ja: 'センサー' },
    palette: 'bg-emerald-50 border-emerald-500 text-emerald-800',
    border: 'border-emerald-500',
    title: 'text-emerald-800',
    summary: 'text-emerald-700',
    miniMap: '#10b981',
  },
  action: {
    label: { en: 'Sound & lights', ja: '音声・ライト' },
    palette: 'bg-orange-50 border-orange-500 text-orange-800',
    border: 'border-orange-500',
    title: 'text-orange-800',
    summary: 'text-orange-700',
    miniMap: '#f97316',
  },
  motion: {
    label: { en: 'Robot motion', ja: 'ロボット動作' },
    palette: 'bg-blue-50 border-blue-500 text-blue-800',
    border: 'border-blue-500',
    title: 'text-blue-800',
    summary: 'text-blue-700',
    miniMap: '#3b82f6',
  },
  control: {
    label: { en: 'Branch & repeat', ja: '分岐・くり返し' },
    palette: 'bg-amber-50 border-amber-500 text-amber-800',
    border: 'border-amber-500',
    title: 'text-amber-800',
    summary: 'text-amber-700',
    miniMap: '#f59e0b',
  },
  utility: {
    label: { en: 'Timing & reuse', ja: '時間・再利用' },
    palette: 'bg-slate-50 border-slate-500 text-slate-800',
    border: 'border-slate-500',
    title: 'text-slate-800',
    summary: 'text-slate-700',
    miniMap: '#64748b',
  },
  flow: {
    label: { en: 'Flow structure', ja: 'フロー構造' },
    palette: 'bg-teal-50 border-teal-500 text-teal-800',
    border: 'border-teal-500',
    title: 'text-teal-800',
    summary: 'text-teal-700',
    miniMap: '#0d9488',
  },
};

export const NODE_CATEGORIES: Record<NodeKind, NodeCategory> = {
  start: 'flow',
  end: 'flow',
  input: 'flow',
  output: 'flow',
  function: 'utility',
  textEdit: 'dialog',
  qrScan: 'sensors',
  tof: 'sensors',
  listen: 'dialog',
  sayText: 'dialog',
  soundEffect: 'action',
  light: 'action',
  gesture: 'motion',
  customGesture: 'motion',
  dance: 'motion',
  walking: 'motion',
  mazeGoal: 'control',
  if: 'control',
  switch: 'control',
  keywordSwitch: 'control',
  counter: 'control',
  coinFlip: 'control',
  randomChoice: 'control',
  wait: 'utility',
};

export const getNodeCategoryStyle = (kind: NodeKind) => NODE_CATEGORY_STYLES[NODE_CATEGORIES[kind]];